import { pilot } from '~/services/serviceInstances';
import { PilotId } from '~/types/PilotId';

export type FolderBulkDeleteRequest = {
  folderId: PilotId;
  documents: number[];
  folders: number[];
  selectAll: boolean;
  reason: string | null;
  extraDetails: string | null;
  force?: boolean;
};

export type FolderBulkDeleteResponse = {
  skippedFolderNames?: string[];
};

type FolderBulkDeleteServerResponse = {
  skipped_folder_names?: string[];
};

export const folderBulkDelete = ({
  folderId,
  ...args
}: FolderBulkDeleteRequest): Promise<FolderBulkDeleteResponse> =>
  pilot
    .put(`folder/${folderId}/delete/`, mapParams(args))
    .then((response: FolderBulkDeleteServerResponse) => mapResponse(response));

const mapParams = ({
  selectAll,
  extraDetails,
  ...rest
}: Omit<FolderBulkDeleteRequest, 'folderId'>) => ({
  ...rest,
  select_all: selectAll,
  extra_details: extraDetails,
});

const mapResponse = (
  response: FolderBulkDeleteServerResponse,
): FolderBulkDeleteResponse => ({
  skippedFolderNames: response.skipped_folder_names,
});
